/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import {
  IconDotsVertical,
  IconDownload,
  IconEye,
  IconPlus,
} from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import ListView from "../../../components/common/ListView";
import CommonModal from "../../../components/common/CommonModal";
import EditViewModal from "./EditViewModal";
import ToggleButton from "../../../components/ToggleButton";
import AddZoneModal from "./AddZoneModal";
import ViewCitiesModal from "./ViewCitiesModal";
import { useForm } from "react-hook-form";
import {
  useFetchZoneData,
  useUpdateZoneData,
  useUpdateZoneStatus,
  useZoneCreateMutation,
} from "../../../apis/zoneAndTierApis";
import MessageModal from "../../../components/MessageModal";
import formatDate from "../../../utilities/helper";
import toast from "react-hot-toast";

type ZoneFormValues = {
  name: string;
  tireId: string | null;
  courierCompanyId: string | null;
  paymentMode: string;
  capacityPerDay: string | null;
  pricePerShipment?: string;
};

export default function ZoneListTab() {
  const [openZone, setOpenZone] = useState<boolean>(false);
  const openZoneToggleModal = () => {
    setOpenZone(!openZone);
  };
  const [citiesArray, setCitiesArray] = useState<any>();

  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => setIsOpen(false);
  const handleViewCities = (cities: any) => {
    setCitiesArray(cities);
    setIsOpen(true);
  };

  // <!!!!!!!!! Api's Hook's !!!!!!!!!>
  const { mutate, isPending: activePending } = useZoneCreateMutation();
  const { data: zoneData, refetch: zoneRefetch } = useFetchZoneData(1, 10, "");
  const { mutate: updateZoneStatus, isPending: statusPending } =
    useUpdateZoneStatus();
  const { mutate: updateZoneData, isPending: zoneUpdatePending } =
    useUpdateZoneData();
  const [editStatus, setEditStatus] = useState<boolean>(false);
  const [zoneItem, setZoneItem] = useState<any>(null);
  const [actionModal, setActionModal] = useState<boolean>(false);
  const [status, setStatus] = useState<string>("");
  const [zoneDataArray, setZoneDataArray] = useState<any>(zoneData);
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    watch,
    formState: { errors },
    setValue,
    control,
  } = useForm<ZoneFormValues>();

  const handleEditData = (item: any) => {
    setEditStatus(!editStatus);
    setZoneItem(item);
    setOpenZone(!isOpen);
  };

  useEffect(() => {
    if (zoneData) {
      setZoneDataArray(zoneData);
    }
  }, [zoneData]);

  const handleToggleStatus = async (zone: any) => {
    const newStatus = zone?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    setZoneItem(zone);

    setStatus(zone.status);
    setActionModal(true);
  };

  const handleUpdateStatus = async () => {
    const newStatus = zoneItem?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    // Optimistically update UI (optional: use local state or refetch later)
    const updatedZoneData = zoneDataArray.zones.map((v: any) =>
      v.id === zoneItem?.id ? { ...v, status: newStatus } : v
    );
    await setZoneDataArray({ ...zoneDataArray, zones: updatedZoneData });
    console.log("setZoneDataArray ", newStatus);

    // Send to API (example)
    await updateZoneStatus({ id: zoneItem?.id, status: newStatus });
    setActionModal(false);
    setZoneItem(null);
  };
  const handleAddZone = (data: any) => {
    mutate(
      { ...data },
      {
        onSuccess: (data) => {
          reset();
          zoneRefetch();
          openZoneToggleModal();
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  const handleUpdateZoneData = (data: any) => {
    updateZoneData(
      {
        id: zoneItem?.id,
        name: data?.name,
        capacityPerDay: data?.capacityPerDay,
        courierCompanyId: data?.courierCompanyId,
        paymentMode: data?.paymentMode,
        tireId: data?.tireId,
        pricePerShipment: data?.pricePerShipment,
      },
      {
        onSuccess: (data) => {
          reset();
          zoneRefetch();
          openZoneToggleModal();
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };
  return (
    <>
      <div className="rounded-3xl">
        <div className="flex items-start">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[30px] ">
            <h1 className="text-3xl text-[#212121]">Zone List</h1>
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch />
            </div>
          </div>
          <div className="relative ml-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={40}
              height={40}
              viewBox="0 0 34 34"
              fill="none"
              className="absolute -bottom-[12.5px] -left-[22.5px] rotate-[2deg] "
            >
              <path
                d="M0.5 0.5C4.94768 14.4784 15.2221 25.8511 28.6786 31.6907L34 34H2.31268L0.5 0.5Z"
                fill="#F7F6F2"
              />
            </svg>

            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1  p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>
              <button
                onClick={openZoneToggleModal}
                className="flex items-center gap-1  p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
              >
                <IconPlus stroke={1.5} size={24} />
              </button>
            </div>
          </div>
        </div>
        <div>
          {" "}
          <ListView
            data={zoneDataArray?.zones ?? []}
            onRowClick={(client) => console.log("Clicked:", client)}
            columns={[
              { label: "#", render: (_, i) => i + 1 },
              {
                label: "Zone Name",
                render: (c: any) => c.name,
              },
              {
                label: "Warehouse",
                render: (c: any) => c.warehouseName,
              },
              { label: "Country", render: (c) => c.countryName },
              {
                label: "Price",
                render: (c) => c.pricePerShipment,
              },
              {
                label: "Capacity",
                render: (c) => c.capacityPerDay,
              },
              {
                label: "Courier Company",
                render: (c) => c.companyName,
              },
              {
                label: "City",
                render: (c: any) => (
                  <button
                    onClick={() => {
                      handleViewCities(c.coverageCityNames);
                    }}
                    className="underline text-[#007AFF]"
                  >
                    View Cities
                  </button>
                ),
              },
              {
                label: "Payment Type",
                render: (c) => c.paymentMode,
              },
              { label: "Date", render: (c) => formatDate(c.createdAt) },
              {
                label: "Status",
                render: (c: any) => (
                  <ToggleButton
                    onChange={() => handleToggleStatus(c)}
                    checked={c.status === "ACTIVE"}
                  />
                ),
              },
              {
                label: "Actions",
                render: (c: any) => (
                  <button
                    onClick={() => {
                      handleEditData(c);
                    }}
                    className="p-2 border rounded-full bg-[#F7F6F2]"
                  >
                    <IconEye />
                  </button>
                ),
              },
            ]}
          />
        </div>
      </div>

      <CommonModal
        title={editStatus ? "Edit Zone" : "Add Zone"}
        open={openZone}
        closeButtonText={"Cancel"}
        onClose={openZoneToggleModal}
        actionButtonText={editStatus ? "Update" : "Add Zone"}
        isPending={editStatus ? zoneUpdatePending : activePending}
        actionButtonOnClick={() => {
          editStatus
            ? handleSubmit(handleUpdateZoneData)()
            : handleSubmit(handleAddZone)();
        }}
      >
        <AddZoneModal
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          clearErrors={clearErrors}
          control={control}
          zoneItem={zoneItem}
        />
      </CommonModal>
      {/* <CommonModal
        title={"Zone Name"}
        open={openEditZone}
        closeButtonText={"Cancel"}
        onClose={openEditZoneToggleModal}
        actionButtonText="Edit"
        actionButtonOnClick={openEditZoneToggleModal}
      >
        <EditViewModal />
      </CommonModal> */}
      <MessageModal
        open={actionModal}
        onClose={() => setActionModal(false)}
        title="Confirmation Required"
        subtitle="Are you sure you want to perform this action?"
        img={status === "ACTIVE" ? "/img/inactive.svg" : "/img/active.svg"}
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        actionButtonOnClick={handleUpdateStatus}
        isPending={statusPending}
        size="md"
      />
      <ViewCitiesModal
        citiesItem={citiesArray}
        open={isOpen}
        onClose={closeModal}
      />
    </>
  );
}
